module.exports = __webpack_public_path__ + "img/stena09.22231845.jpg";